/**
 * Defines the curret Handshake System Version
 */
export const _HANDSHAKE_VERSION = 2

/**
 * Available handshake statuses (Enabled/ Disabled)
 */
export enum HandshakeStatus {
  DISABLED = 0,
  ENABLED = 1
}
